var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActor4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 106,
    viewBox: "0 0 105 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_266)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.3287 88.3897C109.765 68.1693 109.765 35.3854 89.3287 15.165C68.8926 -5.05548 35.759 -5.05549 15.3229 15.165C-5.11323 35.3854 -5.11323 68.1693 15.3229 88.3897C35.759 108.61 68.8926 108.61 89.3287 88.3897Z",
    fill: "#AFCB3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_702_266",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 106,
    height: 105
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3287 88.3897C109.765 68.1693 109.765 35.3854 89.3287 15.165C68.8926 -5.05548 35.759 -5.05549 15.3229 15.165C-5.11323 35.3854 -5.11323 68.1693 15.3229 88.3897C35.759 108.61 68.8926 108.61 89.3287 88.3897Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_702_266)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3501 68.8257H42.3101V82.1832H62.3501V68.8257Z",
    fill: "#F9C2A7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1701 78.4926C50.1901 79.6799 53.5001 80.3923 56.7501 80.422C58.6101 80.4418 60.5101 80.2043 62.3501 79.8877V68.8257H42.3101V75.732C43.7201 76.9589 45.5101 77.8395 47.1701 78.4827V78.4926Z",
    fill: "#EDEDED"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.26 44.0894C73.32 43.6046 74.14 42.813 74.5 42.5459C75.29 41.9522 76.09 42.5657 76.33 43.3375C76.54 44.0301 76.56 44.8117 76.61 45.5241C76.73 47.2754 76.47 48.9971 75.69 50.5802C75.17 51.6389 74.35 52.4997 73.39 53.1528C73.39 53.1528 72.35 53.6772 72.14 52.47C72.14 52.47 73.27 44.0894 73.27 44.0795L73.26 44.0894Z",
    fill: "#F9C2A7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.09 45.1383C73.14 44.792 73.72 44.228 73.97 44.0301C74.54 43.6046 75.11 44.04 75.28 44.5941C75.43 45.0888 75.44 45.6429 75.48 46.1673C75.57 47.4239 75.38 48.6508 74.82 49.7788C74.45 50.5308 73.86 51.1541 73.17 51.6192C73.17 51.6192 72.43 51.9951 72.28 51.1343C72.28 51.1343 73.09 45.1383 73.09 45.1284V45.1383Z",
    fill: "#E1B099"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 44.0894C30.84 43.6046 30.02 42.813 29.66 42.5459C28.87 41.9522 28.07 42.5657 27.83 43.3375C27.62 44.0301 27.6 44.8117 27.55 45.5241C27.43 47.2754 27.69 48.9971 28.47 50.5802C28.99 51.6389 29.8 52.4997 30.77 53.1528C30.77 53.1528 31.81 53.6772 32.02 52.47C32.02 52.47 30.89 44.0894 30.89 44.0795L30.9 44.0894Z",
    fill: "#F9C2A7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.06 45.1383C31.01 44.792 30.43 44.228 30.18 44.0301C29.61 43.6046 29.04 44.04 28.87 44.5941C28.72 45.0888 28.71 45.6429 28.67 46.1673C28.58 47.4239 28.77 48.6508 29.33 49.7788C29.7 50.5308 30.29 51.1541 30.98 51.6192C30.98 51.6192 31.72 51.9951 31.87 51.1343C31.87 51.1343 31.06 45.1383 31.06 45.1284V45.1383Z",
    fill: "#E1B099"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8901 45.6627C73.8901 51.1937 72.9501 56.7841 70.3701 61.573C68.1201 65.7584 64.7401 69.1126 61.1201 71.7841C58.1801 73.951 55.0301 76.484 51.3001 76.1772C47.4201 75.8507 44.4001 72.5064 41.5601 69.8943C37.5701 66.2135 34.4301 61.6522 32.4901 56.2795C31.3001 52.9648 30.7501 49.2346 30.7501 45.6726C30.7501 27.7933 40.4101 16.5532 52.3201 16.5532C64.2301 16.5532 73.8901 27.7933 73.8901 45.6726V45.6627Z",
    fill: "#F9C2A7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.33 88.2287L62.35 81.7676H42.31L17.33 88.2287C17.33 88.2287 5.76003 92.4734 4.47003 105.9H100.18C98.89 92.4734 87.32 88.2287 87.32 88.2287H87.33Z",
    fill: "#F9C2A7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.33 88.2287L62.35 81.7676H42.31L17.33 88.2287C17.33 88.2287 5.76003 92.4734 4.47003 105.9H100.18C98.89 92.4734 87.32 88.2287 87.32 88.2287H87.33Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3301 88.2288L68.8501 83.4497L52.34 105.91L36.01 83.4102L17.3501 88.2387C17.3501 88.2387 5.78005 92.4834 4.49005 105.91H100.2C98.91 92.4834 87.34 88.2387 87.34 88.2387L87.3301 88.2288Z",
    fill: "#3F0700"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.14 94.6504L45.54 105.9H58.62L54.13 94.6504H50.14Z",
    fill: "#1DB2A8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.03 81.9854L46.17 89.7624L50.24 94.6799L52.24 94.6503L54.23 94.6206L58.14 89.5744L52.03 81.9854Z",
    fill: "#1DB2A8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.94 88.7434C55.19 90.2078 53.8 91.88 51.9 91.4644C49.94 91.0389 49.05 89.2084 49.5 87.3483C49.94 85.5376 51.12 84.0238 51.78 82.312L46.16 89.7625L50.23 94.6801L54.22 94.6108L58.13 89.5646L56.48 87.5165C56.32 87.9321 56.14 88.3476 55.94 88.7434Z",
    fill: "#DADADA"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3301 105.9L36.0001 83.4004L22.9401 86.7843L39.6301 98.4103L35.3401 100.28L43.0601 105.9H52.3301Z",
    fill: "#290000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.33 105.94L68.67 83.4297L81.73 86.8136L65.04 98.4396L69.32 100.31L61.61 105.94H52.33Z",
    fill: "#290000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.48 82.2424L42.28 77.6909L52.26 81.8169L62.25 77.6909L72.72 82.2424L57.92 92.0478L52.26 84.0333L46.17 92.0478L32.48 82.2424Z",
    fill: "#E9E9E9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.96 68.5485C64.96 68.5485 70.38 63.4826 71.57 59.0103C71.57 59.0103 65.18 64.7095 62.95 64.1059L64.95 68.5485H64.96Z",
    fill: "#1E0E00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.21 70.0624C41.21 70.0624 34.93 64.7392 33.21 58.0703C33.21 58.0703 40.37 66.253 42.6 65.6396L41.21 70.0624Z",
    fill: "#1E0E00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1501 61.296C59.7001 61.3455 61.6301 62.5526 61.6301 62.5526C64.7401 64.0071 65.5401 67.955 65.5401 67.955C65.5401 67.955 63.4001 70.3 60.7801 71.9623C54.8701 76.8105 52.1601 76.1971 52.1601 76.1971C48.8001 76.1971 46.4401 74.1193 46.4401 74.1193L40.9101 69.835C40.2201 64.9669 44.5201 62.5526 44.5201 62.5526C47.1001 61.3158 47.5601 61.4741 47.5601 61.4741C47.5601 61.4741 51.4201 61.0289 52.3601 62.5427C52.3601 62.5427 53.3301 61.2861 55.9601 61.2861",
    fill: "#251403"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.85 65.3033C52.85 65.3033 50.42 64.106 46.89 65.3923C46.89 65.3923 52.25 71.0124 58.33 65.4616C58.33 65.4616 55.07 63.9576 52.84 65.3033H52.85Z",
    fill: "#F9C2A7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M74.08 19.294C78.94 15.7913 78.41 10.4087 78.41 10.4087C75.58 13.4859 71.44 13.8817 71.44 13.8817C75.73 11.3388 73.6 6.03538 73.6 6.03538C72.26 9.00372 66.3 10.7056 66.3 10.7056C69.19 8.79594 67.39 4.45227 67.39 4.45227C65.37 7.84607 59.33 9.33024 59.33 9.33024C63.3 7.10399 63.72 3.91797 63.72 3.91797C60.18 6.99515 50.54 8.47932 50.54 8.47932C50.54 8.47932 39.91 9.43908 37.27 18.1759C29.5 19.2841 29.43 32.2854 29.97 39.3006L30.46 47.79H32.19C31.42 43.7234 32.19 38.2122 32.19 38.2122C33.38 34.2643 33.99 31.9292 34.75 30.2768C36.59 26.2992 39.46 25.0921 41.29 24.7359L43.03 24.6073C50.64 23.509 52.88 28.852 52.88 28.852C54.06 25.7748 58.03 25.0327 58.03 25.0327C69.6 23.509 71.26 32.5624 71.26 32.5624L72.57 38.321C72.75 40.2405 73.06 44.6832 72.47 47.79H74.2L74.69 39.3006C74.7 39.0334 74.7 38.8058 74.69 38.5981C75.56 33.8685 76.33 26.1508 74.07 19.294H74.08Z",
    fill: "#1E0E00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.67,
    height: 105.94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActor4);
export default __webpack_public_path__ + "static/media/actor4.e6a370eaab78d505b50d1fc182eb7e6f.svg";
export { ForwardRef as ReactComponent };